// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetLocationsRequestModel from '../../model/get-locations-request-model';
import GetLocationsRequestDTO from '../dto/get-locations-request-dto';
import dtoSchema from '../schemas/get-locations-request-schema';

export default abstract class GetLocationsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetLocationsRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.postalCodeCriteria = data.postalCodeCriteria;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  */
  postalCodeCriteria?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetLocationsRequestDTO>): GetLocationsRequestModel;
  static toModel(dto: DeepPartial<GetLocationsRequestDTO> | undefined | null): GetLocationsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetLocationsRequestDTO> | undefined | null): GetLocationsRequestModel | undefined {
    return dto ? new GetLocationsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetLocationsRequestModel> | GetLocationsRequestModel): GetLocationsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      postalCodeCriteria: unwrapped.postalCodeCriteria,
      searchCriteria: unwrapped.searchCriteria,
    } as GetLocationsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetLocationsRequestModel, can not map to GetLocationsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
